export default __webpack_public_path__ + "0d329483dcf073cc6cc1e19321d1ff97.svg";